'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
const LazyVideo = t0 => {
  const $ = _c(10);
  let onLoadedData;
  let props;
  let src;
  if ($[0] !== t0) {
    ({
      src,
      onLoadedData,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onLoadedData;
    $[2] = props;
    $[3] = src;
  } else {
    onLoadedData = $[1];
    props = $[2];
    src = $[3];
  }
  const videoRef = useRef(null);
  let t1;
  let t2;
  if ($[4] !== src) {
    t1 = () => {
      const handleIntersection = entries => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          if (videoRef.current && !videoRef.current.src) {
            videoRef.current.src = src;
          }
          if (videoRef.current) {
            videoRef.current.play().catch(_temp);
          }
        } else {
          if (videoRef.current) {
            videoRef.current.pause();
          }
        }
      };
      const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.1
      });
      if (videoRef.current) {
        observer.observe(videoRef.current);
      }
      return () => {
        if (videoRef.current) {
          observer.unobserve(videoRef.current);
        }
      };
    };
    t2 = [src];
    $[4] = src;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== onLoadedData || $[8] !== props) {
    t3 = <video ref={videoRef} {...props} onLoadedData={onLoadedData} />;
    $[7] = onLoadedData;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default LazyVideo;
function _temp(error) {
  console.error("Error playing video:", error);
}